import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import { lighten } from '@mui/material/styles';

const EditableData = ({label, value, onChange, isRequired=false, min, max, step=1, minWidth='90px', sx}) => {

  const handleChange = (e) => {
    if(min && max) {
      if(Number(e.target.value) >= min && Number(e.target.value) <= max) {
        onChange(Number(e.target.value));
      }
    } else {
      onChange(Number(e.target.value));
    }
  };

  const error = isRequired && value === 0 || value < min || value > max;

  return <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, ...sx}}>
    {
      label &&
      <Typography sx={{minWidth: minWidth, fontWeight: 900}}>{label}<span style={{color: 'red'}}>{isRequired ? '*' : ''}</span></Typography>
    }
    <TextField
      error={error}
      type='number'
      inputProps={{min: min, max: max, step: step }}
      variant='outlined'
      size='small'
      value={value}
      onChange={handleChange}
      sx={{
        width: '100px',
        '& .MuiInputBase-root': {
          bgcolor: error ? lighten('#ff0000', 0.85) : 'transparent'
        }
      }}
    />
  </Box>;
};

EditableData.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  label: PropTypes.string,
  value: PropTypes.number || PropTypes.string,
  isRequired: PropTypes.bool,
  minWidth: PropTypes.string,
  sx: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

export default EditableData;